import { useLocation, useParams, NavLink,useNavigate } from 'react-router-dom';
import React, { useState,useEffect } from 'react'
import { axiosInstance } from "../../utils/axios.js";
import { Calendar, Clock, User, Shield, CreditCard, FileText, AlertTriangle, CheckCircle, X } from 'lucide-react';

const ReserveConfirmContainer = (props) => {
    const labels = ['無断キャンセルや当日キャンセルはキャンセル料をお支払い頂いております','支払い拒否や2週間以上の料金未納は損害賠償の対象となる可能性があることを了承します', '18歳以上の国内在住者であり、提携医療機関の医師の診察に同意します', '下記の利用規約・注意事項に同意します', '現在当院ではインスリンの処方はできません。']; // チェックボックスの文言
    const [checkboxes, setCheckboxes] = useState(new Array(labels.length).fill(false)); // 文言の数に応じてチェックボックスの状態を設定
    const allChecked = checkboxes.every(Boolean);
    const location = useLocation();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [cancelModal, setCancelModal] = useState(false);
    const [deadlineModal, setDeadlineModal] = useState(false);
    const [consultation_time, setConsultationTime] = useState();
    const [doctor_profile, setDoctorProfile] = useState();
    const [subject_id, setSubjectId] = useState('');
    const [last_name, setLastName] = useState('');
    const [profile, setProfile] = useState('');

    useEffect(() => {
        setIsLoading(true);
        axiosInstance.get(`/reservations/doctors_show/${location.state.admin_user_id}?subject_id=${location.state.subject_id}`,{
            headers: {
              'uid': props.token,  // ここにアクセストークンをしっかり渡す
              'Access-Control-Allow-Origin': '*'
            }
          })
          .then(response => {
            console.log(response.data)
            setDoctorProfile(response.data.doctors);
            setSubjectId(response.data.subject_id.name)
            setProfile(response.data.doctors.profile);
            setLastName(response.data.doctors.lastname);
            setIsLoading(false);
          })
          .catch(err => {
          });
      }, []);

    const handleCheckboxChange = (index) => {
        const updatedCheckboxes = [...checkboxes];
        updatedCheckboxes[index] = !updatedCheckboxes[index]; // チェックボックスの状態を切り替える
        setCheckboxes(updatedCheckboxes);
      };


    const DateTimeComponent = ({ isoDate }) => {
        const date = new Date(isoDate);
        
        // 月/日/曜日/何時/何分 のフォーマットを作成
        const formattedDate = date.toLocaleDateString('ja-JP', {
            month: '2-digit', // 月
            day: '2-digit',   // 日
            weekday: 'short', // 曜日
        });
        
        const formattedTime = date.toLocaleTimeString('ja-JP', {
            hour: '2-digit',   // 何時
            minute: '2-digit', // 何分
        });

        console.log(location.state)

        if (location.state.appointmentType === 'initial') {
          setConsultationTime(15)
        } else {
          setConsultationTime(10)
        }
        
        return (
            <div className="reserve_confirm_datetime_display">
                <Calendar className="reserve_confirm_datetime_icon" />
                <span className="reserve_confirm_datetime_text">
                    {`${formattedDate} ${formattedTime}`}から{consultation_time}分間
                </span>
            </div>
        );
    };

    if (isLoading) {
      return (
        <div>
          <div className="loader" style={{ width: '100px', height: '100px' }}></div>
          <div
            style={{
              width: '100%',
              position: 'absolute',
              bottom: '0%',
              height: '80px',
              background: '#FEFBF9',
              zIndex: '12',
            }}
          />
        </div>
      );
    }

    const handleClick = () => {
        setIsLoading(true);
        axiosInstance.get(`/reservations/new?shift_id=${location.state.id}&subject_id=${location.state.subject_id}`, {
            headers: {
              'uid': props.token,  // ここにアクセストークンをしっかり渡す
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
            if (response.data.flag == 1) {
              setIsLoading(false);
              navigate(`/reserve/rediagnose/${id}`, { state: { last_name:last_name, admin_user_id: location.state?.admin_user_id, start_time: location.state?.start_time, id: location.state?.id, subject_id: location.state?.subject_id, shiftIds: location.state.block.shiftIds } });
            } else if (response.data.flag == 2){
                axiosInstance.post('/api/medichat/reservations',{ uid:props.token,id:location.state?.id,short: true, subject_id: location.state.subject_id, shiftIds: location.state.block.shiftIds },{
                    headers: {
                      'uid': props.token,  // ここにアクセストークンをしっかり渡す
                      'Access-Control-Allow-Origin': '*'
                    }
                })
                .then(res => {
                    if(res.data.message == '1'){
                        setIsLoading(false);
                        setShowModal(true);
                    } else if(res.data.message == '3'){
                        setIsLoading(false);
                        setCancelModal(true);
                    } else if(res.data.message == '4'){
                          setIsLoading(false);
                          setDeadlineModal(true);
                    } else {
                        setIsLoading(false);
                        navigate('/mypage/reservation?status=success');
                    }
              })
            } else if(response.data.flag == 4) {
                setIsLoading(false);
                setCancelModal(true);
            }  else {
                setIsLoading(false);
                navigate(`/reserve/diagnose/${id}`, { state: { last_name:last_name, admin_user_id: location.state?.admin_user_id, start_time: location.state?.start_time, id: location.state?.id, subject_id: location.state?.subject_id, shiftIds: location.state.block.shiftIds } });
            }
        });
    }

    const closeModal = () => {
        setShowModal(false);
        navigate('/mypage/reservation');
      };
    
      const closeModal_2 = () => {
        setCancelModal(false);
        navigate('/mypage/reservation');
      };


  if (isLoading) {
    return (
      <div>
      <div className="loader" style={{ width: '100px', height: '100px' }}></div>
        <div
          style={{
            width: '100%',
            position: 'absolute',
            bottom: '0%',
            height: '80px',
            background: '#FEFBF9',
            zIndex: '12',
          }}
        />
      </div>
    );
  }

  return (
    <div className="sunny_container" style={{paddingBottom:'120px',paddingTop:'1rem'}}>
      <div className="reserve_confirm_main_container">
        
        {/* 予約日時セクション */}
        <div className="reserve_confirm_datetime_card">
          <div className="reserve_confirm_card_header">
            <Clock className="reserve_confirm_header_icon" />
            <h3 className="reserve_confirm_card_title">予約日時</h3>
          </div>
          <DateTimeComponent isoDate={location.state?.start_time} />
        </div>

        {/* 担当医セクション */}
        <div className="reserve_confirm_doctor_card">
          <div className="reserve_confirm_card_header">
            <User className="reserve_confirm_header_icon" />
            <h3 className="reserve_confirm_card_title">担当医師</h3>
          </div>
          <div className="reserve_confirm_doctor_content">
            <div className="reserve_confirm_doctor_info">
              <h4 className="reserve_confirm_doctor_name">{last_name}先生</h4>
              <p className="reserve_confirm_doctor_profile">{profile}</p>
            </div>
          </div>
        </div>

        {/* 同意事項セクション */}
        <div className="reserve_confirm_agreement_card">
          <div className="reserve_confirm_card_header">
            <Shield className="reserve_confirm_header_icon" />
            <h3 className="reserve_confirm_card_title">同意事項</h3>
          </div>
          
          <div className="reserve_confirm_checkbox_container">
            {labels.map((label, index) => (
              <label key={index} className="reserve_confirm_checkbox_item">
                <input
                  type="checkbox"
                  checked={checkboxes[index]}
                  onChange={() => handleCheckboxChange(index)}
                  className="reserve_confirm_checkbox_input"
                />
                <div className={`reserve_confirm_custom_checkbox ${checkboxes[index] ? 'checked' : ''}`}>
                  {checkboxes[index] && <CheckCircle className="reserve_confirm_checkbox_icon" />}
                </div>
                <span className="reserve_confirm_checkbox_text">{label}</span>
              </label>
            ))}
          </div>
        </div>

        {/* 利用規約セクション */}
        <div className="reserve_confirm_terms_card" style={{marginBottom:'60px'}}>
          <div className="reserve_confirm_card_header">
            <FileText className="reserve_confirm_header_icon" />
            <h3 className="reserve_confirm_card_title">利用規約・注意事項</h3>
          </div>
          
          <p className="reserve_confirm_terms_notice" style={{textAlign:'left'}}>
            以下の利用規約・注意事項をよくお読みください。
          </p>
          
          <div className="reserve_confirm_terms_content">
            <div className="reserve_confirm_terms_item" style={{textAlign:'left'}}>
              <p>お支払い方法はクレジットカード・銀行振込のみです。</p>
              <p>処方は初診で最大30日分、再診で最大90日分です。</p>
              <p>お支払い完了後2~3日を目安にご自宅にお届けします。</p>
              <p>薬の流通の関係で到着が遅れる場合もございます。念の為早めの受診をお願いしております。</p>
              <p>薬代は処方日数や薬の種類によって値段が変動します。</p>
              <p>診察が混雑している場合、最大15分ほどお待ちいただく場合がございます。</p>
              <p>診察の録音・録画はお控えください。</p>
              <p>血液検査キットは自費負担になります。</p>
            </div>
          </div>
        </div>

        {/* フッターボタン */}
        <div className="footer_content_page">
          <button 
            onClick={allChecked ? (e) => handleClick(e) : null}
            className={`reserve_confirm_submit_button ${allChecked ? 'active' : 'disabled'}`}
          >
            <Shield className="reserve_confirm_submit_icon" />
            <span className="reserve_confirm_submit_text">同意して次へ進む</span>
          </button>
        </div>

        {/* モーダル群 */}
        {showModal && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content warning_modal" onClick={(e) => e.stopPropagation()}>
              <span className="close-button" onClick={closeModal}>
                <X />
              </span>
              <div className="modal_icon warning_icon">
                <AlertTriangle />
              </div>
              <p className="modal_title">予約の競合が発生しました</p>
              <p className="modal_subtitle">同じ時間の予約が先に埋まってしまいました。大変お手数ですが再度予約をお取りください。</p>
            </div>
          </div>
        )}

        {cancelModal && (
          <div className="modal-overlay" onClick={() => closeModal_2()}>
            <div className="modal-content warning_modal" onClick={(e) => e.stopPropagation()}>
              <span className="close-button" onClick={() => closeModal_2()}>
                <X />
              </span>
              <div className="modal_icon warning_icon">
                <AlertTriangle />
              </div>
              <p className="modal_title">予約の重複が検出されました</p>
              <p className="modal_subtitle">お客様の予約が重複しております。すでに診察完了前の予約が入っておりますのでそちらをキャンセルもしくは予約時間変更してご利用ください。</p>
            </div>
          </div>
        )}

        {deadlineModal && (
          <div className="modal-overlay" onClick={() => closeModal_2()}>
            <div className="modal-content warning_modal" onClick={(e) => e.stopPropagation()}>
              <span className="close-button" onClick={() => closeModal_2()}>
                <X />
              </span>
              <div className="modal_icon warning_icon">
                <AlertTriangle />
              </div>
              <p className="modal_title">予約締切時間を過ぎました</p>
              <p className="modal_subtitle">予約締切時間が過ぎました。お手数ですが診察開始時間以内に再度ご予約をお取りください。</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReserveConfirmContainer;
